import { isApiError } from "@bw/shared/api";

/**
 * Map a FAILED self-register (POST /leagues/divisions/{id}/registrations) to ONE
 * honest, English, player-facing sentence — keyed off the HTTP STATUS CODE the
 * backend returns (the backend owns the verdict; the FE never re-derives it):
 *
 *   409 → division full OR already registered (DivisionFullError /
 *         DuplicateRegistrationError) — both are a 409, so the copy covers both
 *         without claiming to know which (the server doesn't distinguish them on the
 *         wire here).
 *   403 | 400 → tier-ineligible OR registration not open (TierIneligibleError /
 *         LeagueNotOpenError).
 *   404 → the division no longer exists / isn't available.
 *   anything else (incl. a non-ApiError / network failure) → a generic retry line.
 *
 * Deliberately does NOT leak the server's raw message or any id — just the honest
 * consequence. A leagues-MODULE-LOCAL util (no cross-module import); the GREEN step
 * renders this string in the division row's inline register-error slot.
 */
export function mapRegisterError(error: unknown): string {
  if (isApiError(error)) {
    switch (error.status) {
      case 409:
        return "This division may be full, or you're already registered.";
      case 403:
      case 400:
        return "You're not eligible for this division, or registration isn't open.";
      case 404:
        return "This division is no longer available.";
    }
  }
  return "We couldn't register you. Please try again.";
}
